import React, {useEffect, useState} from "react";
import "../../assets/css/review.css";
import InnerBanner from "../../components/InnerBanner/InnerBanner";
import { useDispatch } from "react-redux";
import {removeAll} from "../../redux/Cart/Reducer";

const Index = () => {

	const dispatch = useDispatch();
	const [message , setMessage] = useState('');

	useEffect(()=>{
		window.scrollTo(0, 0);
		dispatch(removeAll());
		const urlParams = new URLSearchParams(window.location.search);
		if(urlParams.get('success') && urlParams.get('message')){
			setMessage(urlParams.get('message'));
		}
	},[])


	return (
		<>

			{/* InnerBanner Start Here */}
			<InnerBanner PageName="THANK YOU" />
			{/* InnerBanner End Here */}

			<section className="review-sec mt-5 mb-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="thanks-wrapper post-reviews">
								<p>Thank you for visiting
									Cookies 4 a Cure.</p>
								<p>{message}</p>
							</div>
						</div>
					</div>
				</div>
			</section>

		</>
	);
};

export default Index;
